import { Box, styled } from "@mui/material";
import { useDropzone } from "react-dropzone";
import RejectionFiles from "../RejectionFiles";
import { UploadProps } from "../type";
import DenseBlockContent from "./DenseBlockContent";

export const SingleUploadDenseView = ({
  error = false,
  file,
  helperText,
  sx = {},
  fileName,
  fileUploadMessage,
  singleUpload,
  ...other
}: UploadProps) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    fileRejections,
  } = useDropzone({
    multiple: false,
    ...other,
  });
  const fileMessage =
    fileUploadMessage ?? `only_one_document_is_allowed_to_upload`;
  return (
    <Box
      sx={{
        width: "100%",
        ...sx,
        display: "flex",
        gap: 0.5,
        flexDirection: "column",
      }}
    >
      <DropZoneStyle
        {...getRootProps()}
        sx={{
          ...(isDragActive && { opacity: 0.72 }),
          ...((isDragReject || error) && {
            color: "error.dark",
            borderColor: "error.dark",
            bgcolor: "error.light",
          }),
          //   ...(file && {
          //     padding: "12% 0",
          //   }),
        }}
      >
        <input {...getInputProps()} />

        <DenseBlockContent
          error={!!error}
          fileName={fileName}
          fileMessage={fileMessage}
          singleUpload={singleUpload}
          file={file}
        />
      </DropZoneStyle>

      {fileRejections.length > 0 && (
        <RejectionFiles fileRejections={fileRejections} />
      )}

      {helperText && helperText}
      {/* {typeof file === "string" && (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Box
            sx={{ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" }}
          >
            <Box
              sx={{
                bgcolor: "grey.200",
                color: "grey.800",
                p: 1,
                borderRadius: 1,
                height: "30px",
                display: "flex",
                width: "30px",
                alignItems: "center",
              }}
            >
              <FileIcon />
            </Box>
          </Box>
        </Box>
      )} */}
    </Box>
  );
};

const DropZoneStyle = styled("div")(({ theme }) => ({
  outline: "none",
  overflow: "hidden",
  position: "relative",
  padding: theme.spacing(1, 1),
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create("padding"),
  backgroundColor: theme.palette.grey[100],
  border: `2px dashed ${theme.palette.grey[500_32]}`,
  "&:hover": { opacity: 0.72, cursor: "pointer" },
}));
